import { Room } from "@domain";
import { SyncInteractor } from "@kernel/frontend-react-app";
import {
  DisableRemoteTransceiverInteractor,
  EnableRemoteTransceiverInteractor
} from "./remotes";

export interface ToggleLocalTrackInteractorProps {
  room: Room;
  type: "audio" | "video";
}

export class ToggleLocalTrackInteractor extends SyncInteractor<
  ToggleLocalTrackInteractorProps,
  void
> {
  private enableRemoteTransceiver: EnableRemoteTransceiverInteractor;
  private disableRemoteTransceiver: DisableRemoteTransceiverInteractor;

  private constructor() {
    super();
    this.enableRemoteTransceiver = EnableRemoteTransceiverInteractor.create();
    this.disableRemoteTransceiver = DisableRemoteTransceiverInteractor.create();
  }

  public execute(props: ToggleLocalTrackInteractorProps): void {
    const stream = props.room.localParticipant?.stream || null;
    if (!stream) return;
    if (stream.hasEnabledTrack(props.type)) {
      stream.stop(props.type);
      this.disableRemoteTransceiver.execute(props);
      return;
    }
    stream.restart(props.type);
    this.enableRemoteTransceiver.execute(props);
  }

  public static create(): ToggleLocalTrackInteractor {
    return new ToggleLocalTrackInteractor();
  }
}
